import routeRegex from "route_regex"

const pageLoad = {
  onReady: (callback) => {
    // if Turbo is loaded yet (essential.js file)
    if (!window.Turbo) {
      if (document.readyState === "loading") {
        window.addEventListener("DOMContentLoaded", callback)
      } else {
        setTimeout(callback)
      }
      // register callback for the turbo:load event but only after the load
      // event to prevent that the callback is called twice on inital page load
      window.addEventListener("load", () => pageLoad.onTurboLoad(callback))
    } else {
      pageLoad.onTurboLoad(callback)
      // if the load event has already occurred
      if (document.readyState === "complete") {
        // call callback immeditaly since turbo won't call it anymore
        setTimeout(callback)
      }
    }
  },

  onTurboLoad: (callback) => {
    window.addEventListener("turbo:load", event => {
      // workaround for redirects to only call the callback once although this
      // event gets triggered twice
      // it also ignores the hash param since the server url doesn't include it
      if (event.detail.url.split("#")[0] === window.gon.currentUrl) callback()
    })
  },

  onClick: (callback) =>
    document.addEventListener("turbo:click", callback),

  preventTurbo: (url) => {
    if (!url) return false
    if (url.match(/contact_modal/)) return true
    if (url.match(/contact_us/)) return true
    const excludedUrls = [
      new RegExp(`^${window.gon.loginPath}$`),
      new RegExp(`^${window.gon.registerPath}$`),
      new RegExp(`^${window.gon.logoutPath}$`),
      new RegExp(`^${window.gon.trainerPath}`),
      new RegExp(`^${window.gon.setupMissionCompletePath}$`),
      new RegExp(`^${window.gon.profileSetupPath}$`),
      routeRegex("?/?$"),
      /^\/(login|registration)\/google$/,
      /^\/admin/
    ]
    const path = (new URL(url, window.location)).pathname
    return excludedUrls.some((matcher) => matcher.test(path))
  }
}

pageLoad.onClick((event) => {
  if (pageLoad.preventTurbo(event?.detail?.url)) {
    event.preventDefault()
  }
})

export default pageLoad
